import { useMutation } from '@tanstack/react-query'
import { api } from '@/lib/api-client'
import { MutationConfig } from '@/lib/react-query'
import { SyncResult } from './upload-fastbound-file'

export const syncFastboundFile = (file: File): Promise<SyncResult> => {
    const formData = new FormData()
    formData.append('file', file)
    return api.post('/v2/subscriptions/sync/fastbound', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    })
}

type UseSyncFastboundFileOptions = {
    mutationConfig?: MutationConfig<typeof syncFastboundFile>
}

export const useSyncFastboundFile = ({ mutationConfig }: UseSyncFastboundFileOptions = {}) => {
    return useMutation({
        mutationFn: syncFastboundFile,
        ...mutationConfig,
    })
}


